(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ApplicationContainer", [], factory);
	else if(typeof exports === 'object')
		exports["ApplicationContainer"] = factory();
	else
		root["ApplicationContainer"] = factory();
})(window, function() {
return 